import { API, APICall } from '../Api'

export default {
  name: 'Exports',

  methods: {
    async download (id) {
      const Request = {
        Type    : APICall.Report.Export.Get.Type,
        Endpoint: APICall.Report.Export.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async generate (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.Report.Export.Save.Type,
        Endpoint: APICall.Report.Export.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async all (data) {
      const Request = {
        Type    : APICall.Report.Export.List.Type,
        Endpoint: APICall.Report.Export.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    }

  }

}
